import {
    QUERY_CITIC_RISK_MONITORING_START,
    QUERY_CITIC_RISK_MONITORING_SUCCESS,
    QUERY_CITIC_RISK_MONITORING_FAILURE,
    CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT,
} from './fundRiskMonitoringConstants';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import moment from 'moment';

const initialState = {
    citicRiskMonitoringList: [],
    queryCiticRiskMonitoringStatus: ACTION_STATUS.READY,
    citicRiskMonitoringSearchFields: {
        fundCode: '',
        date: moment(),
    }
};

export default function fundRiskMonitoringReducer(state = initialState, action) {
    switch (action.type) {
        case CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT:
            return {
                ...state,
                citicRiskMonitoringSearchFields: {
                    ...state.citicRiskMonitoringSearchFields,
                    [action.payload.name]: action.payload.value,
                }
            };
        case QUERY_CITIC_RISK_MONITORING_START:
            return {
                ...state,
                queryCiticRiskMonitoringStatus: ACTION_STATUS.LOGINING,
            };
        case QUERY_CITIC_RISK_MONITORING_SUCCESS:
            return {
                ...state,
                citicRiskMonitoringList: action.payload.data,
                queryCiticRiskMonitoringStatus: ACTION_STATUS.SUCCESS,
            };
        case QUERY_CITIC_RISK_MONITORING_FAILURE:
            return {
                ...state,
                queryCiticRiskMonitoringStatus: ACTION_STATUS.ERROR,
            };
        default:
            return state;
    }
}
